import React from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonVariant,
    H6Emphasized,
    Sheet,
    YStack,
} from 'smoothie';

interface IncomeSplitTargetBalanceInfoSheetProps {
    isOpen: boolean;
    onClose: () => void;
}

const IncomeSplitTargetBalanceInfoSheet = ({
    isOpen,
    onClose,
}: IncomeSplitTargetBalanceInfoSheetProps) => {
    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            showCloseButton={false}
            isInsideModal
        >
            <YStack gap={14} paddingTop={20} maxWidth={500}>
                <H6Emphasized>Target balance</H6Emphasized>
                <BodyMediumRegular color="$gray900">
                    We&apos;ll send money to this account to build up to, or
                    replenish, the target balance.
                </BodyMediumRegular>
                <Button
                    marginTop={16}
                    text="Dismiss"
                    variant={ButtonVariant.PRIMARY}
                    onPress={onClose}
                />
            </YStack>
        </Sheet>
    );
};

export default IncomeSplitTargetBalanceInfoSheet;
